import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=4d936634&"
import script from "./Default.vue?vue&type=script&lang=ts&"
export * from "./Default.vue?vue&type=script&lang=ts&"
import style0 from "./Default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports